/**
 * DashboardSkeleton — 3-line skeleton placeholder rendered while auth/role are
 * resolving. Mirrors the final dashboard layout (welcome banner, status strip,
 * hero card) so the perceived load is shorter and less jarring.
 */
import { Skeleton } from "@/components/ui/skeleton";

export function DashboardSkeleton() {
  return (
    <div className="space-y-4 sm:space-y-6 animate-in fade-in duration-300">
      {/* Welcome banner */}
      <Skeleton className="h-28 sm:h-36 w-full rounded-2xl sm:rounded-3xl" />
      {/* Status strip chips */}
      <div className="flex gap-2">
        <Skeleton className="h-9 flex-1 rounded-full" />
        <Skeleton className="h-9 flex-1 rounded-full" />
        <Skeleton className="h-9 flex-1 rounded-full" />
        <Skeleton className="h-9 flex-1 rounded-full" />
      </div>
      {/* Today hero card */}
      <Skeleton className="h-40 sm:h-48 w-full rounded-2xl" />
    </div>
  );
}
